/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import Container from "../../components/Container";
import NavigationHeader from "../../components/NavigationHeader";
import LoadingIndicator from "../../components/LoadingIndicator";
import EmptyView from "../../components/EmptyView";
import Stack from "../../components/ui/Stack";
import Icon from "../../components/ui/Icon";
import PaymentMethodItem from "../../components/payment/PaymentMethodItem";
import { ROUTES } from "../../constants/constants";
import { usePaymentMethods } from "../../lib/react-query/usePaymentMethods";

const ClientPaymentMethods = () => {
  const { data: paymentMethods, isLoading } = usePaymentMethods();
  const methods = paymentMethods || [];

  return (
    <Container>
      <NavigationHeader
        title="Saved payment methods"
        subtitle="Payment methods saved for your bookings. You can remove any you no longer use."
        back={ROUTES.CLIENT_PAYMENTS}
      />

      {isLoading && <LoadingIndicator page />}

      {!isLoading && methods.length === 0 && (
        <EmptyView
          icon={Icon.StorageBox}
          description="You don't have any saved payment methods yet"
        />
      )}

      {!isLoading && methods.length > 0 && (
        <Stack $gap="1rem">
          {methods.map((method) => (
            <PaymentMethodItem key={method.id} paymentMethod={method} />
          ))}
        </Stack>
      )}
    </Container>
  );
};

export default ClientPaymentMethods;
